/* Trendybed — product.js
   PDP-interacties: variant-picker, gallery-thumbnails, qty-stepper, dynamisch
   totaalbedrag. Add-to-cart loopt via cart.js (data-cart-form). */
(function () {
  "use strict";

  const money = (cents) => {
    const sym = (window.Shopify && window.Shopify.currency && window.Shopify.currency.symbol) || "€";
    return sym + (cents / 100).toFixed(2).replace(".", ",");
  };

  document.querySelectorAll("[data-product-form]").forEach(function (root) {
    const dataEl = root.querySelector("[data-variants-json]");
    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    // De prijs-elementen (onder de titel) staan BUITEN de <form> → scope op de .pdp.
    const scope = root.closest(".pdp") || document;
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = scope.querySelector("[data-price]");
    const compareEl = scope.querySelector("[data-compare-price]");
    const discountEl = scope.querySelector("[data-discount]");
    const addBtn = root.querySelector("[data-add-btn]");
    const totalEl = root.querySelector("[data-add-total]");
    const qtyInput = root.querySelector('input[name="quantity"]');
    const optionInputs = root.querySelectorAll("[data-option-index]");
    let currentVariant = null;

    function selectedOptions() {
      const opts = [];
      optionInputs.forEach(function (input) {
        if (input.type === "radio") {
          if (input.checked) opts[Number(input.dataset.optionIndex)] = input.value;
        } else {
          opts[Number(input.dataset.optionIndex)] = input.value;
        }
      });
      return opts;
    }

    function currentQty() {
      return Math.max(1, Number(qtyInput ? qtyInput.value : 1) || 1);
    }

    function renderTotal() {
      if (totalEl && currentVariant) totalEl.textContent = money(currentVariant.price * currentQty());
    }

    function update() {
      const opts = selectedOptions();
      // Enkel-variant-producten hebben geen optie-inputs → pak direct de enige variant,
      // anders zou .every() op een lege opts-array niets matchen en de knop uitschakelen.
      const variant = optionInputs.length
        ? variants.find((v) => v.options.every((o, i) => o === opts[i]))
        : variants[0];
      currentVariant = variant;
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.dataset.state = "unavailable"; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
          if (discountEl) {
            discountEl.textContent = "-" + Math.round((1 - variant.price / variant.compare_at_price) * 100) + "%";
            discountEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (discountEl) discountEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.dataset.state = variant.available ? "available" : "soldout";
        const label = addBtn.querySelector("[data-add-label]");
        if (label) {
          label.textContent = variant.available
            ? addBtn.dataset.add || "In winkelmand"
            : addBtn.dataset.soldout || "Uitverkocht";
        }
      }
      // levertijd/voorraad-regel bijwerken per variant (zelfde model als HiP: op basis van voorraad)
      const stockLine = root.closest(".pdp, section").querySelector("[data-stock-line]");
      if (stockLine) {
        const txt = stockLine.querySelector("[data-stock-text]");
        const inStock = variant.inventory_quantity > 0 || (variant.inventory_managed === false && variant.available);
        const dot = stockLine.querySelector("[data-stock-dot]");
        stockLine.classList.remove("pdp__stock--in", "pdp__stock--out");
        if (inStock) {
          stockLine.classList.add("pdp__stock--in");
          const c = stockLine.dataset.inColor || "";
          if (txt) { txt.textContent = stockLine.dataset.inText || ""; txt.style.color = c; }
          if (dot) dot.style.background = c;
        } else {
          stockLine.classList.add("pdp__stock--out");
          const c = stockLine.dataset.outColor || "";
          if (txt) { txt.textContent = stockLine.dataset.outText || "Niet op voorraad"; txt.style.color = c; }
          if (dot) dot.style.background = c;
        }
      }
      renderTotal();
      // variant-media in gallery tonen
      if (variant.featured_media && variant.featured_media.id) {
        const thumb = root.closest(".pdp, section").querySelector('[data-gallery-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url.toString());
      }
    }

    optionInputs.forEach((input) => input.addEventListener("change", update));

    // Hersync bij (terug)navigatie: bfcache/form-restore kan de knopprijs stale
    // laten. pageshow vuurt bij eerste load én bij herstel uit bfcache.
    window.addEventListener("pageshow", update);

    // Qty-stepper
    root.querySelectorAll("[data-qty-plus],[data-qty-minus]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!qtyInput) return;
        let q = currentQty();
        q = btn.hasAttribute("data-qty-plus") ? q + 1 : Math.max(1, q - 1);
        qtyInput.value = q;
        const disp = root.querySelector("[data-qty-display]");
        if (disp) disp.textContent = q;
        renderTotal();
      });
    });

    update();
  });

  // Gallery-thumbnails
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    const mainImg = gallery.querySelector("[data-gallery-main] img");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        const src = thumb.dataset.mediaSrc;
        if (mainImg && src) {
          mainImg.src = src;
          if (thumb.dataset.mediaSrcset) mainImg.srcset = thumb.dataset.mediaSrcset;
          mainImg.alt = thumb.dataset.mediaAlt || mainImg.alt;
        }
        gallery.querySelectorAll("[data-gallery-thumb]").forEach((t) => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  });

  // Lightbox / afbeelding vergroten
  (function () {
    var box = document.querySelector("[data-zoom-lightbox]");
    if (!box) return;
    var boxImg = box.querySelector("[data-zoom-img]");
    function open() {
      var mainImg = document.querySelector("[data-gallery-main] img");
      if (!mainImg) return;
      boxImg.src = mainImg.currentSrc || mainImg.src;
      boxImg.alt = mainImg.alt || "";
      box.hidden = false;
      document.body.style.overflow = "hidden";
    }
    function close() {
      box.hidden = true;
      document.body.style.overflow = "";
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-zoom-open]")) { e.preventDefault(); open(); }
      else if (e.target.closest("[data-zoom-close]") || e.target === box) close();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !box.hidden) close(); });
  })();

  // Scroll naar sectie (bv. Maatgids-link)
  document.addEventListener("click", function (e) {
    const t = e.target.closest("[data-scroll-to]");
    if (!t) return;
    const el = document.getElementById(t.getAttribute("data-scroll-to"));
    if (el) {
      e.preventDefault();
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  // Recently viewed opslaan
  const handleEl = document.querySelector("[data-product-handle]");
  if (handleEl && window.TrendybedRecentlyViewed) {
    window.TrendybedRecentlyViewed.push(handleEl.getAttribute("data-product-handle"));
  }
})();
